import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components/macro';
import { Waypoint } from 'react-waypoint';

/**
 * Hack to quickly apply stroke values to the child SVG path. Ideally this
 * should be the SVG itself and not a wrapper
 */
const SvgWrapper = styled.div`
  transition: all 0.5s ease-in;
  opacity: ${props => (props.shouldAnimate ? 1 : 0)};
  ${props =>
    pathAnimations(props.length, props.pathCount, props.shouldAnimate)};
`;

const pathAnimations = (lengthArray, pathCount, shouldAnimate) => {
  let pathCSS = '';
  for (let i = 0; i < pathCount; i += 1) {
    const delay = lengthArray[i] / 1200;
    /**
     * If we're on a path beyond the first, then we need to find what the
     * previous delay was, so that we can set the transition delay for this new
     * path to be that.
     */
    const previousDelay = i > 0 ? lengthArray[i - 1] / 1200 : 0;

    pathCSS += `
      path:nth-child(${i + 1}) {
        transition: stroke-dashoffset ${delay}s ease-in;
        stroke-dasharray: ${lengthArray[i]};
        stroke-dashoffset: ${shouldAnimate ? 0 : lengthArray[i]};
        transition-delay: ${previousDelay * i}s;
      }
    `;
  }
  return pathCSS;
};

const AnimateSvg = props => {
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const [strokeLength, setStrokeLength] = useState(null);
  const [pathCount, setPathCount] = useState(null);
  const svgRef = useRef(null);

  useEffect(() => {
    /** TODO: make this less fragile, in case we can't get elements */
    const animationClasses = svgRef.current.getElementsByClassName(
      'animate-me'
    );
    // console.log('svg: ' + svgRef.current);
    // console.dir('animationClasses: ' + animationClasses[0]);

    // let pathsCollection = [];
    // if (animationClasses) {
    //   for (var i = 0; i < animationClasses.length; ++i) {
    //     // console.log('path: ' + animationClasses[i]);
    //     console.log(animationClasses[i].getElementsByTagName('path'));
    //     pathsCollection.push(animationClasses[i].getElementsByTagName('path'));
    //   }
    // }
    // animationClasses &&
    //   animationClasses.map((item, index) => {

    //   });

    const paths = Array.from(animationClasses);
    const tempPathArray = [];
    setPathCount(paths.length);
    paths.forEach(path => {
      tempPathArray.push(path.getTotalLength());
    });
    setStrokeLength(tempPathArray);
  }, []);

  const Svg = props.svg;

  return (
    <Waypoint onEnter={() => setShouldAnimate(true)} bottomOffset="30%">
      <SvgWrapper
        ref={svgRef}
        length={strokeLength}
        shouldAnimate={shouldAnimate}
        pathCount={pathCount}
        {...props}
      >
        <Svg />
      </SvgWrapper>
    </Waypoint>
  );
};

export default AnimateSvg;
